export default __webpack_public_path__ + "static/media/logo-example-09.a254d273.jpg";